export enum HttpStatusCodes {
  Ok = 200,
  Found = 302,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  ConflictError = 409,
  InternalServerError = 500,
  ServiceUnavailable = 503,
}
